import { isProspectPlayer } from './prospectUtils';

/**
 * Filtre « Tipo de Jugador » de la liste des joueurs : états mutuellement exclusifs.
 * Le bucket NCAA n'est pas une valeur de players.type mais une appartenance au vivier
 * de formation US — NCAA, High School, Overtime Elite, NBA Academy, PIT (cf.
 * prospectUtils) — réservé à super admin / admin pro.
 *
 * ⚠️ Les valeurs de fil (3 / 'ncaa') sont PERSISTÉES dans les filtres sauvegardés en
 * localStorage : on renomme le libellé, jamais le code.
 */
export const PLAYER_TYPE = { ALL: 0, CANTERA: 1, PRO: 2, NCAA: 3 };

/**
 * `excludeProspects` : sous PRO, écarte les joueurs du vivier même lorsqu'ils sont
 * typés `pro` — les buckets deviennent alors disjoints.
 *
 * ⚠️ Activé UNIQUEMENT pour les rôles qui voient le bucket (canUseProspectFilter).
 * Pour les autres, ces joueurs quitteraient PRO sans avoir aucun filtre où
 * réapparaître : ils ne subsisteraient que sous « Tous », ce qui se lit comme un bug.
 */
export const matchesPlayerType = (player, filter, { excludeProspects = false } = {}) => {
  switch (filter) {
    case PLAYER_TYPE.CANTERA:
      return player.type?.toLowerCase() === 'cantera';
    case PLAYER_TYPE.PRO:
      return (
        player.type?.toLowerCase() === 'pro' &&
        (!excludeProspects || !isProspectPlayer(player))
      );
    case PLAYER_TYPE.NCAA:
      return isProspectPlayer(player);
    default:
      return true;
  }
};

/**
 * Variante « chaîne » du même filtre, utilisée par le sélecteur Tous / Pro / Cantera /
 * NCAA + des écrans de recherche. `row` est une ligne enrichie côté back (informe,
 * intel, document, vidéo, medical, medida) qui porte player_type +
 * player_competitions_detail.
 */
export const PLAYER_TYPE_VALUE = { ALL: 'all', PRO: 'pro', CANTERA: 'cantera', NCAA: 'ncaa' };

/**
 * Les filtres Rankings / Seguimiento stockent historiquement '' quand aucun type n'est
 * sélectionné : on le ramène sur 'all' pour le sélecteur (qui exige une valeur connue).
 */
export const normalizeTypeToggleValue = (value) =>
  value === PLAYER_TYPE_VALUE.PRO || value === PLAYER_TYPE_VALUE.CANTERA || value === PLAYER_TYPE_VALUE.NCAA
    ? value
    : PLAYER_TYPE_VALUE.ALL;

export const matchesPlayerTypeValue = (row, value, { excludeProspects = false } = {}) => {
  if (!value || value === PLAYER_TYPE_VALUE.ALL) return true;
  if (value === PLAYER_TYPE_VALUE.NCAA) return isProspectPlayer(row);
  const type = (row.player_type || row.type)?.toLowerCase();
  if (value === PLAYER_TYPE_VALUE.PRO) {
    return type === 'pro' && (!excludeProspects || !isProspectPlayer(row));
  }
  return type === value;
};
